<template>
  <div>
    <slot />
  </div>
</template>

<script>
import lightGallery from 'lightgallery';
require('lightgallery/css/lightgallery');
const Macy = require('macy');

export default {
  mounted() {
    this.initializeMasonryLayout();
    this.initializePhotoGallery();
  },

  beforeDestroy() {
    this.gallery.destroy();
  },

  methods: {
    initializeMasonryLayout() {
      this.masonary = new Macy({
        container: this.$el,
        columns: 3,
        breakAt: {
          1200: { columns: 2 }
        }
      });
    },

    initializePhotoGallery() {
      this.gallery = lightGallery(this.$el, {
        licenseKey: 'AF34D6D8-9E014319-8D6E417B-DAC31F16',
        selector: '.gallery-block-photo-link',
        allowMediaOverlap: true,
        download: false,
        plugins: [],
        speed: 500
      });
    }
  }
};
</script>

<style lang="scss">
.lg-backdrop.in {
  background: rgba(0, 0, 0, 0.85);
}

.lg-sub-html {
  @apply mx-auto;
  padding-bottom: 2rem;
  padding-top: 1.5rem;
  font-weight: normal;

  a {
    @apply underline;
  }

  @screen md {
    padding-left: 15%;
    padding-right: 15%;
  }

  @screen lg {
    padding-left: 25%;
    padding-right: 25%;
  }
}
</style>
